module.exports = "mutation assignTo($adviceRequestId:String!,$userId:String!){assignTo(adviceRequestId:$adviceRequestId,userId:$userId)}"